<template>
  <div>
    <div class="panel-heading d-flex align-center py-2">
      <h4 class="panel-title">
        Send Notification
      </h4>
    </div>

    <div class="panel-body">
      <div class="row">
        <!-- customersList -->
        <div class="col-12 col-md-6 px-4">
          <div class="row">
            <div class="col-md-4">
                <v-checkbox
                v-model="form.addall"
                label="Send To All"
                color="success"
                :disabled="customersList.length === 0"
                dense
                />
            </div>
            <div class="col-md-8">
              <v-select
                v-if="showSearch"
                v-model="customer"
                autocomplete
                :items="customersList"
                item-value="value"
                label="Select Customer"
                return-object
                clearable
                single-line
                @input="customerSelected()"
              />

              <v-text-field
                v-else
                label="Customer"
              />
            </div>

            <div class="col-12">
              <table class="table table-framed">
                <thead>
                  <tr>
                    <th style="width: 50px">#</th>
                    <th>Name</th>
                    <th>Phone Number</th>
                    <th style="width: 50px" />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(customer, index) in selectedCustomers"
                    :key="index"
                  >
                    <td>{{ index +1 }}</td>
                    <td>{{ customer.full_name }}</td>
                    <td>{{ customer.phone_number }}</td>
                    <td>
                      <div
                        @click="removeCustomer(index)"
                        style="cursor: pointer;"
                      >
                        <i
                          style="font-size: 20px; color: red"
                          class="fa fa-close"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- title & body -->
        <div class="col-12 col-md-6 px-4">
          <div class="row">
            <div class="col-12">
              <v-text-field
                v-model="form.title"
                label="Title"
              />
            </div>

            <div class="col-12">
              <v-text-field
                v-model="form.body"
                label="Body"
              />
            </div>

            <div class="col-12">
              <v-btn
                @click="submit()"
                style="height: auto;"
                depressed
                color="primary"
                :loading="loading"
              >
                Send
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  data() {
    return {
      showSearch: true,
      loading: false,
      customer: {},
      customersList: [],
      selectedCustomers: [],
      form: {
        addall: false,
        customer_ids: [],
        title: null,
        body: null
      }
    }
  },

  mounted() {
    this.getCustomers()
  },

  methods: {
    getCustomers() {
      let token = localStorage.getItem('access_token')

      Axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.customersList = response.data.data.map((item) => {
            item.text = item.full_name + ' - Tel: ' + item.phone_number
            item.value = item.user_id

            return item
          })
        })
    },

    customerSelected() {
      if (!this.customer) return

      const found = this.selectedCustomers.find(el => el.user_id === this.customer.user_id)
      if (found) {
        return swal({
          title: '',
          text: 'Customer already in the list',
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      this.selectedCustomers.push({ ...this.customer })
      this.customer = null
      this.showSearch = false
      setTimeout(() => {
        this.showSearch = true
      }, 50)
    },

    removeCustomer(index) {
      this.selectedCustomers.splice(index, 1)
    },

    clearData() {
      this.selectedCustomers = []
      this.customer = null
      this.form = {
        customer_ids: [],
        title: null,
        body: null
      }
    },

    submit() {
      this.form.customer_ids = this.selectedCustomers.map(el => el.user_id)

      if (this.form.addall === false && this.form.customer_ids.length === 0) {
        return swal({
          title: '',
          text: 'Please select customer',
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      if (!this.form.title || this.form.title.length === 0) {
        return swal({
          title: '',
          text: 'Please enter title',
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      if (!this.form.body || this.form.body.length === 0) {
        return swal({
          title: '',
          text: 'Please enter body',
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      this.loading = true

      let token = localStorage.getItem('access_token')

      Axios
        .post('api/send-notification', this.form, { headers: { Authorization: 'Bearer ' + token } })
        .then(() => {
          this.clearData()
          swal({
            title: 'Sent',
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notification/sendNotification.vue